export const TOGGLE_MOBILE_HIDE_FILTER = 'TOGGLE_MOBILE_HIDE_FILTER';
export const TOGGLE_MOBILE_HIDE_SEARCH = 'TOGGLE_MOBILE_HIDE_SEARCH';
export const TOGGLE_SHOW_FULL_INFO_MARKER_MOBILE = 'TOGGLE_SHOW_FULL_INFO_MARKER_MOBILE';